import { Controller } from "@hotwired/stimulus"

// Generic carousel controller
// Targets:
//   - slide: elements to show/hide (uses "hidden" class)
//   - dot: navigation dots (toggles activeClass/inactiveClass)
// Values:
//   - index: current slide index (default 0)
//   - loop: wrap around at ends (default false)
//   - activeClass: class for active dot (default "bg-brand_main")
//   - inactiveClass: class for inactive dots (default "bg-gray-300")
export default class extends Controller {
  static targets = ["slide", "dot"]
  static values = {
    index: { type: Number, default: 0 },
    loop: { type: Boolean, default: false },
    activeClass: { type: String, default: "bg-brand_main" },
    inactiveClass: { type: String, default: "bg-gray-300" }
  }

  connect() {
    this.showSlide(this.indexValue)
  }

  next() {
    const nextIndex = this.indexValue + 1
    if (nextIndex < this.slideTargets.length) {
      this.goTo(nextIndex)
    } else if (this.loopValue) {
      this.goTo(0)
    }
  }

  previous() {
    const prevIndex = this.indexValue - 1
    if (prevIndex >= 0) {
      this.goTo(prevIndex)
    } else if (this.loopValue) {
      this.goTo(this.slideTargets.length - 1)
    }
  }

  goTo(indexOrEvent) {
    const index = typeof indexOrEvent === "number"
      ? indexOrEvent
      : parseInt(indexOrEvent.currentTarget.dataset.index, 10)
    this.indexValue = index
    this.showSlide(index)
  }

  showSlide(index) {
    this.slideTargets.forEach((slide, i) => {
      slide.classList.toggle("hidden", i !== index)
    })

    this.dotTargets.forEach((dot, i) => {
      dot.classList.toggle(this.activeClassValue, i === index)
      dot.classList.toggle(this.inactiveClassValue, i !== index)
    })
  }
}
